/**
 * Pseudo-locale generator for visual stress testing. Wraps every leaf
 * string in `[ … ]`, doubles vowels, and adds diacritics so layout breakage
 * surfaces immediately. Used by Storybook decorators (DS Wave B) and by
 * `PSEUDO=1 pnpm build` to ship a build with pseudo strings inline.
 *
 * Pseudo is NOT exposed at runtime to end users — it's a debugging tool.
 */
const VOWEL_MAP = {
    a: 'á',
    e: 'é',
    i: 'í',
    o: 'ó',
    u: 'ú',
    A: 'Á',
    E: 'É',
    I: 'Í',
    O: 'Ó',
    U: 'Ú',
};
/** Wrap a single string in pseudo-locale brackets, leaving ICU braces intact. */
export function pseudoLocaliseString(input) {
    // Don't transform inside ICU placeholders `{...}`
    let depth = 0;
    let out = '';
    for (const ch of input) {
        if (ch === '{')
            depth += 1;
        if (depth === 0) {
            out += VOWEL_MAP[ch] ?? ch;
        }
        else {
            out += ch;
        }
        if (ch === '}')
            depth = Math.max(0, depth - 1);
    }
    return `[${out} ··]`;
}
function transform(value) {
    if (typeof value === 'string')
        return pseudoLocaliseString(value);
    if (value === null || typeof value !== 'object')
        return value;
    if (Array.isArray(value))
        return value.map(transform);
    const out = {};
    for (const [k, v] of Object.entries(value)) {
        out[k] = transform(v);
    }
    return out;
}
/**
 * Recursively pseudo-localise every leaf string in a nested resource bundle.
 */
export function pseudoLocaliseBundle(bundle) {
    return transform(bundle);
}
//# sourceMappingURL=pseudo.js.map